import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useClientId } from '../../_hooks/useClientId';
import { queryKeys } from './queryKeys';

interface ContactAdvisorDTO {
  name: string;
  phone: string | null;
  email: string | null;
  address: string | null;
  avatar: string | null;
  avatarUrl: string | null;
  website: string | null;
  websiteText: string | null;
  calendarUrl: string | null;
  additionalText: string | null;
  additionalRepresentatives:
    | {
        name: string;
        role: string | null;
        phone: string | null;
        email: string | null;
      }[]
    | null;
}

interface FetcherParams {
  clientId: number;
}

const fetchContactAdvisor = ({ clientId }: FetcherParams): Promise<ContactAdvisorDTO> => {
  return authFetch(urlWithParams('/Consumer/ContactAdviser', { clientId }));
};

export const useContactAdvisorQuery = () => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.contactAdvisor(clientId),

    () => fetchContactAdvisor({ clientId }),

    {
      cacheTime: 0,
    },
  );
};
